<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdservico }}</div>
                </div>
                
                <div class="form-item flexible">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmservico" required maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <TipoGrupoServico class="form-item flexible" v-model:tipoSelecionado="objEdicao.idgruposervico" />

                <ServicoCdMedicaoSelect class="form-item flexible" v-model:opcaoSelecionada="objEdicao.cdmedicao" />

                <div class="form-item" style="flex: 0 0 150px;">
                    <label class="label-caption">Limite diário</label>
                    <input type="text" class="input-right" v-model="edAgendamentoLimiteDia" v-number maxlength="3" />
                </div>

                <div class="form-item" style="flex: 0 0 150px;">
                    <label class="label-caption">Minutos/Hectar</label>
                    <input type="text" class="input-right" v-model="edMnHectare" v-number maxlength="3" />
                </div>
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
            </div>

            <div class="row-end">
                <label for="ckAgendamento">Agendamento por data</label>
                <input id="ckAgendamento" type="checkbox" class="input-checkbox" v-model="ckAgendamento" />
            </div>

            <div class="row-end">
                <label for="ckCalculoFracionado">Cálculo de valor fracionado</label>
                <input id="ckCalculoFracionado" type="checkbox" class="input-checkbox" v-model="ckCalculoFracionado" />
            </div>

            <div class="row-end">
                <label for="ckExportaOperador">Exportar para aplicativo do operador</label>
                <input id="ckExportaOperador" type="checkbox" class="input-checkbox" v-model="ckExportaOperador" />
            </div>


            <div class="row-end">
                <label for="ckapp_produtor">Permitir solicitação por aplicativo do produtor</label>
                <input type="checkbox" class="input-checkbox" id="ckapp_produtor" v-model="objEdicao.ckapp_produtor" true-value="S" false-value="N" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarServico } from '@/models/Servico';
import { Funcoes } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import ServicoCdMedicaoSelect from '@/selects/estaticos/ServicoCdMedicaoSelect.vue';
import TipoGrupoServico from '@/selects/TipoGrupoServico.vue';

const emit=defineEmits(['close', 'salvo']);
const props=defineProps({idEdicao: {type: Number, default: 0}});

const ckAgendamento = ref(false);
const ckAtivo = ref(false);
const ckCalculoFracionado = ref(false);
const ckExportaOperador = ref(false);
const edAgendamentoLimiteDia = ref(null);
const edMnHectare = ref(null);
const objEdicao = criarServico();
const isLoading = ref(false);

const submitForm = async () => {
    try {
        objEdicao.agendamento           = ckAgendamento.value ? 'S' : 'N';
        objEdicao.ativo                 = ckAtivo.value ? 'S' : 'N';
        objEdicao.ckcalculofracionado   = ckCalculoFracionado.value ? 'S' : 'N';
        objEdicao.ckexportaoperador     = ckExportaOperador.value ? 'S' : 'N';
        objEdicao.agendamento_limitedia = Funcoes.integerFromString(edAgendamentoLimiteDia.value);
        objEdicao.mnhectare             = Funcoes.integerFromString(edMnHectare.value);

        const response = await genericPut('/cad/servico', objEdicao);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            alert(response.erro);
        }
    } catch (error) {console.error('Error:', error);}
}

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('servico', props.idEdicao);
                Object.assign(objEdicao, req[0]);
                edAgendamentoLimiteDia.value = Funcoes.formatInteger(objEdicao.agendamento_limitedia);
                edMnHectare.value            = Funcoes.formatInteger(objEdicao.mnhectare);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.idlogin         = globalStore.idlogin;
        ckAgendamento.value       = objEdicao.agendamento === 'S';
        ckAtivo.value             = objEdicao.ativo === 'S';
        ckCalculoFracionado.value = objEdicao.ckcalculofracionado === 'S';
        ckExportaOperador.value   = objEdicao.ckexportaoperador === 'S';
    }finally{isLoading.value=false;}
}

onMounted(lerDados)
</script>